// photo received status of an inv batch item
export const PHOTO_RECEIVED_STATUS = {
  COMPLETED : 'completed',
  PENDING   : 'pending'
}

// put_away_status of an inv batch item
export const PUT_AWAY_STATUS = {
  COMPLETED : 'completed',
  PENDING   : 'pending',
  PARTIAL   : 'partial'
}

export const HIDDEN_COLUMN = {
  PENDING_RECEIVE: [
    'photo_received_date',
    'photo_received_by',
    'photo_received_status',
    'photography_date',
    'photography_by',
    'photo_edited_date',
    'photo_edited_by',
    'photography_status',
    'quantity_rejected',
    'quantity_put_away',
    'put_away_date',
    'put_away_by',
    'put_away_status',
    'photo_edited_status',
    'photo_upload_status',
    'action'
  ],
  COMPLETED_RECEIVE: [
    'photo_received_status',
    'photography_date',
    'photography_by',
    'photo_edited_date',
    'photo_edited_by',
    'photography_status',
    'quantity_rejected',
    'quantity_put_away',
    'put_away_date',
    'put_away_by',
    'put_away_status',
    'photo_edited_status',
    'photo_upload_status'
  ],
  PENDING_PHOTOGRAPHY: [
    'photo_received_date',
    'photo_received_by',
    'photo_received_status',
    'photography_date',
    'photography_by',
    'photography_status',
    'photo_edited_date',
    'photo_edited_by',
    'quantity_put_away',
    'put_away_date',
    'put_away_by',
    'put_away_status',
    'photo_edited_status',
    'photo_upload_status'
  ],
  COMPLETED_PHOTOGRAPHY: [
    'photo_received_date',
    'photo_received_by',
    'photo_received_status',
    'photography_status',
    'photo_edited_date',
    'photo_edited_by',
    'quantity_put_away',
    'put_away_date',
    'put_away_by',
    'put_away_status',
    'photo_edited_status',
    'photo_upload_status'
  ],
  PENDING_PHOTO_EDIT: [
    'photo_received_date',
    'photo_received_by',
    'photo_received_status',
    'quantity',
    'photo_edited_date',
    'photo_edited_by',
    'photography_status',
    'quantity_rejected',
    'quantity_put_away',
    'put_away_date',
    'put_away_by',
    'put_away_status',
    'photo_edited_status',
    'photo_upload_status',
    'action'
  ],
  COMPLETED_PHOTO_EDIT: [
    'photo_received_date',
    'photo_received_by',
    'photo_received_status',
    'quantity',
    'photography_status',
    'quantity_rejected',
    'quantity_put_away',
    'put_away_date',
    'put_away_by',
    'put_away_status',
    'photo_edited_status',
    'photo_upload_status',
    'action'
  ],
  PENDING_PUT_AWAY: [
    'photo_received_date',
    'photo_received_by',
    'photo_received_status',
    'photo_edited_date',
    'photo_edited_by',
    'photography_status',
    'put_away_date',
    'put_away_by',
    'photo_edited_status',
    'photo_upload_status',
    'action',
    'inventory_batch_code',
    'id'
  ],
  COMPLETED_PUT_AWAY: [
    'photo_received_date',
    'photo_received_by',
    'photo_received_status',
    'photography_status',
    'photo_edited_date',
    'photo_edited_by',
    'photo_edited_status',
    'photo_upload_status',
    'put_away_status',
    'quantity',
    'action'
  ],
  ITEM_LIST: [
    'quantity_rejected',
    'quantity',
    'quantity_put_away',
    'action',
    'id',
    'put_away_date',
    'put_away_status',
    'put_away_by'
  ],
  WAREHOUSE_READY: [
    'photo_received_date',
    'photo_received_by',
    'photo_received_status',
    'photography_status',
    'photo_edited_date',
    'photo_edited_by',
    'quantity_put_away',
    'put_away_date',
    'put_away_by',
    'put_away_status',
    'photo_edited_status',
    'photo_upload_status',
    'action'
  ]
}